import {useState, useEffect, useRef} from 'react';
import clsx from "clsx";
import Icon from "../../../elements/Icon/Icon";
import Button from "../../../elements/Button/Button";
import styles from './UserFilter.module.scss'
import {useSelector} from "react-redux";
import useFilter from "../../../../hooks/useFilter";

const UserFilter = ({isDesktop}) => {
    const {invoices} = useSelector((state) => state.invoices);
    const {changeFilter, filters} = useFilter({invoices});
    const {users} = useSelector((state) => state.user);
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [isUserListOpen, setIsUserListOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const ref = useRef();
    let filteredUsers = users?.filter((user) =>
        user.email.toLowerCase().includes(searchQuery));

    const toggleFilterList = () => {
        setIsFilterOpen(!isFilterOpen);
    };

    const toggleUserList = () => {
        setIsUserListOpen(!isUserListOpen);
    }

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value.toLowerCase());
    };

    const handleChangeFilter = (key, value) => {
        const newValue = filters[key] === value ? "all" : value;
        changeFilter(key, newValue);
    };

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                setIsFilterOpen(false);
            }
        };

        isFilterOpen &&
        document.addEventListener('click', handleOutsideClick);

        return () => {
            document.removeEventListener('click', handleOutsideClick);
        };
    }, [isFilterOpen]);

    useEffect(() => {
        filteredUsers = users?.filter((user) =>
            user.email.toLowerCase().includes(searchQuery)
        );
    }, [searchQuery]);


    return (
        <div className={styles.filter} ref={ref}>
            <Button className={styles.filterButton} onClick={toggleFilterList}>
                Filter {isDesktop && 'by user'}
                <Icon
                    name="arrow-down"
                    size={11}
                    color={'var(--color-teal)'}
                    customStyle={{
                        transition: 'transform 350ms ease-in-out',
                    }}
                />
            </Button>
            {isFilterOpen && (
                <div className={styles.listContainer}>
                    <label className={styles.label}>Search by user</label>
                    <input
                        type="text"
                        className={styles.input}
                        value={searchQuery}
                        onChange={handleSearchChange}
                        placeholder="Search..."
                    />
                    <ul className={styles.list}>
                        <li className={styles.sectionHeader} onClick={toggleUserList}>
                            <Button className={styles.allButton}>
                                <Icon
                                    name='arrow-right'
                                    size={11}
                                    color={'var(--color-teal)'}
                                    customStyle={{
                                        transition: 'transform 350ms ease-in-out',
                                        marginRight: '8px',
                                    }}
                                />
                                All Users
                            </Button>
                        </li>
                        {isUserListOpen && filteredUsers && filteredUsers.length > 0 && (
                            filteredUsers.map((user) => (
                                <li key={user.email}>
                                    <Button
                                        className={clsx(styles.statusFilter, {
                                            [styles.active]: filters.user === user.email,
                                        })}
                                        onClick={() =>
                                            handleChangeFilter("user", filters.user === user.email ? "all" : user.email)
                                        }
                                        value={user.email}
                                    >
                                        <p className={styles.filterText}>{user.email}</p>
                                    </Button>
                                </li>
                            ))
                        )}

                        {isUserListOpen && filteredUsers.length === 0 && (
                            <li className={styles.noUsers}>No users found</li>
                        )}

                        <li className={styles.sectionHeader}>Filter by Status</li>
                        <li>
                            <Button
                                className={clsx(styles.statusFilter, {
                                    [styles.active]: filters.userStatus === "active",
                                })}
                                onClick={() =>
                                    handleChangeFilter('userStatus', 'active')
                                }
                            >
                                <p className={styles.filterText}>Active</p>
                            </Button>
                        </li>
                        <li>
                            <Button
                                className={clsx(styles.statusFilter, {
                                    [styles.active]: filters.userStatus === "disabled",
                                })}
                                onClick={() =>
                                    handleChangeFilter('userStatus', 'disabled')
                                }
                            >
                                <p className={styles.filterText}>Disabled / Inactive</p>
                            </Button>
                        </li>
                    </ul>
                </div>
            )}
        </div>
    );
};

export default UserFilter;
